// src/layouts/PrivateLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import CuteSidebar from '../components/layout/CuteSidebar';

function PrivateLayout() {
  return (
    <div className="app-layout">
      <CuteSidebar />
      {/* Main content with margin for collapsed sidebar */}
      <main className="app-main">
        <Outlet />
      </main>

      <style>{`
        .app-layout {
          min-height: 100vh;
          background: #f8fafc;
        }
        
        .app-main {
          margin-left: 72px;
          min-height: 100vh;
          transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
      `}</style>
    </div>
  );
}

export default PrivateLayout;
